import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { ChevronRight } from "lucide-react";
import "./ProductDropdown.css"; 
import { useDispatch, useSelector } from "react-redux";
import { setCurrentCategoryData, setRelatedProducts } from "../../store/slice";
import { fetchRelaPro } from "../util";

const SubCategoryDropdown = ({
  subCategories,
  catProducts,
  productSlug,
  catSlug,
  productName,
  openSubCategory,
  setOpenSubCategory,
  isOpen,
  categoryName,
  selectedSubSlug = "",
  selectedProductSlug = "",
  onClose,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.data);

  useEffect(() => {
    if (!isOpen) {
      setOpenSubCategory(null);
    }
  }, [isOpen, setOpenSubCategory]);

  const handleSubCategoryHover = (_subCatSlug, subCatName) => {
    setOpenSubCategory(subCatName || null);
  };

  const handleProductClick = (subCategoryName, product) => {
    if (!product || !product._id) {
      console.error("Product is undefined or missing _id:", product);
      return;
    }

    dispatch(setRelatedProducts(fetchRelaPro(products, productSlug, subCategoryName, product.productSlug)));
    dispatch(setCurrentCategoryData({ cat: productSlug, subCat: subCategoryName }));

    localStorage.setItem("selectedCategory", categoryName);
    localStorage.setItem("selectedProductId", product._id);

    navigate(`/Products/${productSlug}/${subCategoryName}/${product.productSlug}`, {
      state: { product },
    });

    onClose();
  };

  const handleProductClick2 = (product) => {
    if (!product || !product._id) {
      console.error("Product is undefined or missing _id:", product);
      return;
    }

    dispatch(setCurrentCategoryData({ cat: productSlug, subCat: '' }));
    dispatch(setRelatedProducts(fetchRelaPro(products, productSlug, 'uuuuuu', product.productSlug)));

    localStorage.setItem("selectedCategory", categoryName);
    localStorage.setItem("selectedProductId", product._id);

    navigate(`/Products/${productSlug}/${product.productSlug}`, {
      state: { product },
    });

    onClose();
  };

  const navigateToSubCategory = ({ catSlug, subCatSlug, subCatName }) => {
    dispatch(setCurrentCategoryData({ cat: catSlug, subCat: subCatSlug }));
    localStorage.setItem("selectedCategory", categoryName);
    localStorage.setItem("selectedSubCategory", subCatName);

    navigate(`/product-page/${catSlug}/${subCatSlug}`);
    onClose();
  };

  const openSubCategoryData = subCategories?.find((subCat) => subCat.subCatName === openSubCategory);

  return (
    <>
      <ul className="subcategory-list">
        {subCategories?.length > 0 &&
          subCategories.map((subCat) => (
            <li
              key={subCat.subCategorySlug}
              className={`subcategory-item ${openSubCategory === subCat.subCatName ? "open" : ""} ${
                selectedSubSlug === subCat.subCategorySlug || selectedSubSlug === subCat.subCatName ? "selected" : ""
              }`}
            >
              <div
                onMouseEnter={() => handleSubCategoryHover(subCat.subCategorySlug, subCat.subCatName)}
                onClick={(e) => {
                  e.stopPropagation();
                  navigateToSubCategory({
                    catSlug: productSlug,
                    subCatSlug: subCat.subCategorySlug,
                    subCatName: subCat.subCatName,
                  });
                }}
                className={`subcategory-title ${openSubCategory === subCat.subCatName ? "active-subcategory" : ""} ${
                  selectedSubSlug === subCat.subCategorySlug || selectedSubSlug === subCat.subCatName ? "selected" : ""
                }`}
              >
                {subCat.subCatName}
                <ChevronRight size={14} className="chevron-icon" />
              </div>
            </li>
          ))}

        {catProducts?.length > 0 &&
          catProducts.map((prod) => (
            <li
              key={prod._id}
              className={`product-item2 ${selectedProductSlug === prod.productSlug ? "selected" : ""}`}
              onMouseEnter={() => handleSubCategoryHover(prod.productSlug, "")}
              onClick={(e) => {
                e.stopPropagation();
                handleProductClick2(prod);
              }}
            >
              {prod.prodName}
            </li>
          ))}
      </ul>

      {openSubCategoryData && (
        <ul className="product-list">
          {openSubCategoryData.products?.length > 0 ? (
            openSubCategoryData.products.map((product) => (
              <li
                key={product._id}
                className={`product-item ${selectedProductSlug === product.productSlug ? "selected" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleProductClick(openSubCategoryData.subCategorySlug, product);
                }}
              >
                {product.prodName}
              </li>
            ))
          ) : (
            <li className="no-products">No Products Available</li>
          )}
        </ul>
      )}
    </>
  );
};

export default SubCategoryDropdown;